import React from 'react';
import { Tag } from 'antd';
import moment from 'moment';

const ScheduleDiffTag = ({ date }) => {
    if (!date) return null;

    const diffDate = moment(date, 'YYYY-MM-DD')
        .startOf('day')
        .diff(moment().startOf('day'), 'days');

    if (diffDate === 0) {
        return <Tag color="#096dd9">Hôm nay</Tag>;
    }

    if (diffDate > 0) {
        return <Tag color="#f50">Còn lại {diffDate} ngày</Tag>;
    }

    return <Tag color="red">Cách đây {Math.abs(diffDate)} ngày</Tag>;
};

export default ScheduleDiffTag;